import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { DateHandlingService } from '../../../services/date-handling.service';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GridModule } from '@progress/kendo-angular-grid';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-case-stats',
  templateUrl: './caseStats.component.html',
  styleUrls: ['./caseStats.component.scss'],
  imports: [
    NgxLoadingModule,
    MatCardModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatIconModule,
    GridModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ],
})
export class CaseStatsComponent implements OnChanges {
  private dateSvc = inject(DateHandlingService);
  private dbs = inject(DashboardService);
  private ss = inject(SessionStorageService);
  private router = inject(Router);

  @Input() solutionId;
  @Input() start;
  @Input() end;
  @Input() selectedUnit;

  loading = false;
  app = this.ss.get('currentApp');
  data = [];
  assessmentType = 'ALL';
  level = 'UNIT_ONLY';
  unitList = [];
  limit30 = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.solutionId && changes.solutionId.previousValue !== undefined) ||
      (changes.end && changes.end.previousValue === null) ||
      changes.selectedUnit
    ) {
      this.updateData(true, true);
    }
  }

  updateData(clear?, topLevel?) {
    if (clear) {
      this.unitList = [];
    }

    if (topLevel) {
      this.level = 'UNIT_ONLY';
    }

    this.loading = true;

    this.dbs
      .getCaseStats(
        this.selectedUnit,
        this.solutionId,
        this.dateSvc.toUseableString(this.start, 'start'),
        this.dateSvc.toUseableString(this.end, 'end'),
        this.assessmentType,
        this.level
      )
      .subscribe(x => {
        this.data = x.Summary;
        this.loading = false;
      });
  }

  handleRowClick(ev) {
    if (ev.column.field === 'UnitName') {
      if (ev.dataItem.Units >= 1) {
        if (
          (this.unitList.length &&
            this.unitList[this.unitList.length - 1].UnitID !==
              ev.dataItem.UnitID) ||
          !this.unitList.length
        ) {
          this.unitList.push(ev.dataItem);
        }
        this.selectedUnit = ev.dataItem.UnitID;
        this.level = 'UNIT_CHILDREN';
        this.updateData();
      }
    } else if (
      ev.column.field === 'Users' ||
      ev.column.field === 'UsersWithCases'
    ) {
      if (!this.unitList.length) {
        this.unitList.push(ev.dataItem);
      }
      this.selectedUnit = ev.dataItem.UnitID;
      this.level = 'UNIT_USERS';
      this.updateData();
    }
  }

  goBack() {
    if (this.unitList.length > 1) {
      this.selectedUnit = this.unitList[this.unitList.length - 2].UnitID;
      this.level = 'UNIT_CHILDREN';
      this.updateData();
      this.unitList.pop();
    } else if (this.unitList.length === 1) {
      this.selectedUnit = this.unitList[0].UnitID;
      this.level = 'UNIT_ONLY';
      this.updateData(true);
      this.unitList.pop();
    } else {
      this.selectedUnit = this.unitList[this.unitList.length - 1].UnitID;
      this.level = 'UNIT_ONLY';
      this.updateData();
      this.unitList.pop();
    }
  }

  goToProfile(ev, id) {
    this.router.navigate([`/li/questionnaire/${id}`]);
  }
}
